/*
 * CFM custom security voucher by Jorge Casas on 23/05/2023
 */
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {
  generateHeader,
  generateHeaderCFM,
  generateHeaderTelevia,
  generateHeaderSchutz,
  generateHeaderSolarever,
  generateHeaderCirculoDeCredito,
  generateHeaderCirculoLaboral,
  generateHeaderRUV,
  generateHeaderGeldmacht,
  generateHeaderCajaPopular9Agosto,
} from 'lib/pdfs/Common';
import { requestDownloadFileToConverBase64 } from '../../containers/assets/actions.js';
import { NotPicture } from './logoNoPicture';
import { output, signedCell, signedDateCell } from 'lib/pdfs/signature';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generateEmployeesAssetsPDF = async (record, subcompany, options = {}) => {
  if (subcompany.id === '627e848892aa100028148dab') {
    const header = await generateHeaderCFM(`${subcompany.name} \nVale de Resguardo`);

    const footerES = {
      absolutePosition: { x: 30, y: 750 },
      text: [' Sistemas \n', ' Administración \n', ' Colegio Franco Mexicano\n'],
      color: '#45535b',
      fontSize: 7,
      pageBreak: 'after',
    };

    const footerFR = {
      absolutePosition: { x: 30, y: 750 },
      text: [' Informatique \n', ' Administration\n', ' Colegio Franco Mexicano\n'],
      color: '#45535b',
      fontSize: 7,
    };

    var docDefinition = {
      content: [
        /*
         *First page, language Spanish
         */
        header,
        {
          margin: [0, 0, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: `Lycée Français de \nGuadalajara`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `Políticas y Procedimientos Administrativos`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '100',
              text: `Fecha: ${moment().format('DD/MM/YYYY')}`,
              style: 'textStyle',
            },
          ],
        },
        {
          text: 'PRÉSTAMO DE EQUIPO DE INFORMÁTICA DEL COLEGIO',
          style: 'textStyle',
          bold: true,
          alignment: 'left',
        },
        { text: 'Ficha de recepción de material', style: 'textStyle', alignment: 'center' },
        {
          text: 'Préstamo de equipo propiedad del Colegio Franco Mexicano de Guadalajara, al maestro:',
          style: 'textStyle',
          alignment: 'left',
        },
        {
          margin: [50, 20, 50, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'ID', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'MARCA', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'MODELO', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'NÚMERO DE SERIE', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
            dontBreakRows: true,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 200, '*'],
            body: [
              [
                {
                  text: [
                    { text: 'Fecha ', style: 'textStyle', fontSize: 10 },
                    { text: '______________', style: 'lineStyle', color: '#45535b' },
                  ],
                  alignment: 'left',
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
        {
          text: [
            'Es necesaria la autorización de la dirección y el aviso a Sistemas al correo ',
            { text: 'sistemas@cfm.edu.mx', bold: true, decoration: 'underline', color: '#1483cc' },
            ' para poder hacer uso de este equipo fuera del colegio (durante los periodos de clase o durante las vacaciones escolares). \n\n',
            'El prestatario se compromete a guardar el equipo en un lugar seguro y a cuidarlo. \n\n',
            'En caso de la pérdida o de daño fuera del colegio, la administración podrá solicitar al prestatario (o a la persona responsable del daño), una compensación económica. \n\n',
            'Los equipos deben regresarse completos (incluyendo cargadores y cables). \n\n',
            'Me comprometo a cuidar el equipo recibido y a guardarlo en un lugar seguro.',
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 70, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  border: [false, false, false, false],
                  text: [
                    {
                      text: 'Nombre y firma \n\nAdministración (Equipo de Informática)',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'left',
                  border: [false, true, false, false],
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  border: [false, false, false, false],
                  text: [
                    {
                      text: `Nombre y firma \n\n${record.name} ${record.lastname}`,
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'right',
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
        footerES,
        /*
         *Second page, language French
         */
        header,
        {
          margin: [0, -17, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: `Lycée Français de \nGuadalajara`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `Politiques et procédures administratives`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '100',
              text: `Date: ${moment().format('DD/MM/YYYY')}`,
              style: 'textStyle',
            },
          ],
        },
        {
          text: 'EMPRUNT DE MATERIEL INFORMATIQUE DE L’ETABLISSEMENT',
          style: 'textStyle',
          bold: true,
          alignment: 'left',
        },
        { text: 'Fiche de réception de matériel', style: 'textStyle', alignment: 'center' },
        {
          text: 'Prêt de matériel propriété du Lycée Français de Guadalajara, au professeur suivant: ',
          style: 'textStyle',
          alignment: 'left',
        },
        {
          margin: [50, 20, 50, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'ID', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'MARQUE', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'MODÈLE', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'NUMÉRO DE SÉRIE', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
            dontBreakRows: true,
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 200, '*'],
            body: [
              [
                {
                  text: [
                    { text: 'Date ', style: 'textStyle', fontSize: 10 },
                    { text: '______________', style: 'lineStyle', color: '#45535b' },
                  ],
                  alignment: 'left',
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
        {
          text: [
            'Est-il nécessaire d’obtenir l’autorisation de la direction et l’avis aux services informatiques à l’adresse ',
            { text: 'sistemas@cfm.edu.mx', bold: true, decoration: 'underline', color: '#1483cc' },
            ' sont nécessaires pour pouvoir utiliser ce matériel en dehors de l’établissement (pendant les périodes de cours ou pendant les vacances scolaires). \n\n',
            `L'emprunteur s’engage à garder le matériel dans un endroit sécurisé et à en prendre soin. \n\n`,
            'En cas de perte ou de dégradation hors de l’établissement l’administration pourra décider de demander à l’emprunteur (ou à la personne responsable des dégradations) une compensation financière. \n\n',
            'Les équipements doivent être rendus complet (chargeurs et câbles compris). \n\n',
            'Je m’engage à prendre soin du matériel reçu et à le stocker en lieu sûr.',
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 70, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  border: [false, false, false, false],
                  text: [
                    {
                      text: 'Nom et signature \n\nAdministration (Services Informatiques)',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'left',
                  border: [false, true, false, false],
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  border: [false, false, false, false],
                  text: [
                    {
                      text: `Nom et signature \n\n${record.name} ${record.lastname}`,
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'right',
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
        footerFR,
      ],
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },

        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options);
  } else if (subcompany.id === '6470ebf5395397006752c63c') {
    const header = await generateHeaderTelevia('INFRAESTRUCTURA \nDTIC-FM-02');

    var docDefinition = {
      content: [
        /*
         *First page, language Spanish
         */
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: ``,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `FORMATO 1.2a RESPONSIVA DE \nRECURSOS INFORMÁTICOS`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `Fecha de Expedición Doc: ${moment().format('DD/MM/YYYY')}`,
              style: 'textStyle',
              alignment: 'right',
            },
          ],
        },
        {
          margin: [0, 45, 0, 0],
          text: 'Aceptación de las Condiciones \n\n',
          style: 'textStyle',
          bold: true,
        },
        {
          text: [
            '“El Usuario” está enterado y se compromete a acatar las condiciones establecidas en ',
            'DTINORM-02 Lineamientos de TI para Usuarios Finales.',
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 30, 0, 0],
          text: `Empleado: ${record.name} ${record.lastname}`,
          style: 'textStyle',
          bold: true,
        },
        {
          margin: [0, 30, 0, 0],
          text: 'Recibí el equipo que se menciona a continuación:',
          style: 'textStyle',
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          text: `El cual me comprometo a cuidar, mantener en buen estado y utilizar única y exclusivamente para asuntos relacionados con mi actividad laboral. En caso de su extravío, daño ó uso inadecuado, me responsabilizo a pagar el costo de reparación o la reposición del equipo.`,
          style: 'textStyle',
        },
        {
          margin: [0, 100, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: 'Nombre y firma de quien entrega',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Nombre y firma \n\n${record.name} ${record.lastname}`,
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'right',
                },
              ],
              [
                {
                  colSpan: 3,
                  text: '\n\n\n\n',
                  border: [false, false, false, false],
                  alignment: 'left',
                },
              ],
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: 'Nombre y firma Infraestructura Seguridad',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Nombre y firma Infraestructura Gerencia`,
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'left',
                    },
                  ],
                  alignment: 'right',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },

        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options);
  } else if (subcompany.id === '64dbb47cd647ce005c8497ed') {
    //Schutz
    const header = await generateHeaderSchutz({
      width: '*',
      text: `Fecha de Expedición Doc: ${moment().format('DD/MM/YYYY')}`,
      style: 'textStyle',
      alignment: 'right',
    });

    var docDefinition = {
      content: [
        /*
         *First page, language Spanish
         */
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: ``,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `Chemical & Schutz \n Vale de Resguardo`,
              bold: true,
              fontSize: 16,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: ``,
              style: 'textStyle',
              alignment: 'right',
            },
          ],
        },
        {
          margin: [0, 45, 0, 0],
          text: 'Aceptación de las Condiciones \n\n',
          style: 'textStyle',
          bold: true,
        },
        {
          text: [
            {
              text: `Por medio de la presente hago constar que recibí de Chemical & Schutz High Performance Lubricants,
              S.A. de C.V. los activos que se mencionan a continuación, los cuales me han sido asignados como
              herramientas de trabajo y me comprometo a cuidar y resguardar.`,
              alignment: 'justify',
            },
          ],
          style: 'textStyle',
        },
        {
          margin: [0, 30, 0, 0],
          text: `Empleado: ${record.name} ${record.lastname}`,
          style: 'textStyle',
          bold: true,
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          text: [
            {
              text: `Es de mi conocimiento que el mal uso de los equipos o el uso para actividades que no estén
              consideradas como de trabajo podrán ser sancionadas por la compañía dependiendo de la gravedad de
              la causa.`,
              alignment: 'justify',
            },
          ],
          style: 'textStyle',
        },
        {
          margin: [0, 100, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 150, '*'],
            body: [
              [
                { text: '', border: [false, false, false, false] },
                {
                  text: `${record.name} ${record.lastname}\n\n Nombre y firma de quien recibe`,
                  style: 'tableRow',
                  bold: true,
                  fontSize: 10,
                  alignment: 'center',
                  border: [false, true, false, false],
                },
                { text: '', border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },

        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options);
  } else if (
    subcompany.id === '65cba3ad17e3eb0056c000d2' ||
    subcompany.id === '65d517b5b1bdc9005635dd71' ||
    subcompany.id === '65d518cbb1bdc9005635df15' ||
    subcompany.id === '65d519f4b1bdc9005635e03d' ||
    subcompany.id === '65e1dd46a1f8f4004b0b5489' ||
    subcompany.id === '65e1dd82a1f8f4004b0b551a' ||
    subcompany.id === '65e1dd96a1f8f4004b0b55ab' ||
    subcompany.id === '65e1dda8a1f8f4004b0b563c' ||
    subcompany.id === '65e1ddbea1f8f4004b0b56cd' ||
    subcompany.id === '65e1ddcba1f8f4004b0b575e' ||
    subcompany.id === '65e1dde3a1f8f4004b0b57ef' ||
    subcompany.id === '65e1de0ea1f8f4004b0b5880' ||
    subcompany.id === '65e1de96a1f8f4004b0b5911'
  ) {
    //Solarever
    const header = await generateHeaderSolarever({
      width: '*',
      text: `Fecha de Expedición Doc: ${moment().format(
        'DD/MM/YYYY'
      )}\n\n Revisión: 1\n\n Fecha de revisión: 03/12/2021`,
      style: 'textStyle',
      fontSize: 7,
      alignment: 'right',
    });

    var docDefinition = {
      content: [
        /*
         *First page, language Spanish
         */
        header,
        {
          margin: [0, -10, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: ``,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `Grupo Solarever`,
              bold: true,
              fontSize: 12,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: ``,
              style: 'textStyle',
              alignment: 'right',
            },
          ],
        },
        {
          margin: [0, -7, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: ``,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: 350,
              text: `Formato de responsiva de equipo de cómputo`,
              bold: true,
              fontSize: 10,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: ``,
              style: 'textStyle',
              alignment: 'right',
            },
          ],
        },
        {
          margin: [0, -15, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: ``,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: `Código: GS-RH-06`,
              bold: true,
              fontSize: 6,
              style: 'textStyle',
              alignment: 'center',
            },
            {
              width: '*',
              text: ``,
              style: 'textStyle',
              alignment: 'right',
            },
          ],
        },
        {
          margin: [0, 10, 0, 0],
          text: 'Aceptación de las Condiciones \n\n',
          style: 'textStyle',
          bold: true,
          fontSize: 8,
        },
        {
          text: [
            {
              text: `${record.name} ${record.lastname} `,
              bold: true,
              alignment: 'justify',
              fontSize: 8,
              style: 'textStyle',
            },
            {
              text: `por medio de la presente hago constar que he leído, acepto, cumpliré y velaré por que se cumpla la política correspondiente para la asignación, uso y control del equipo de cómputo. Hago constar que se me hace entrega de un equipo con las características especificadas en la tabla de la sección inferior, del cual soy el único responsable y que utilizaré exclusivamente para el desarrollo de actividades de trabajo en `,
              alignment: 'justify',
              fontSize: 8,
              style: 'textStyle',
            },
            {
              text: `GRUPO SOLAREVER MEXICO `,
              bold: true,
              alignment: 'justify',
              fontSize: 8,
              style: 'textStyle',
            },
            {
              text: `en lo sucesivo la “Solarever”. \n\nLos equipos deben estar resguardados y bajo el control del empleado en todo momento. En caso de que el equipo asignado fuese objeto de un daño, ilícito, robo o extravío se deberá tratar según lo indicado el departamento de Sistemas, la gerencia correspondiente y el área de Recursos Humanos.\n\nEn caso de terminar mi relación laboral con Grupo Solarever México, se deberá según lo indicado el departamento de Sistemas, la gerencia correspondiente y el área de Recursos Humanos. \n\nEl área de Sistemas, Gerencia y Recursos Humanos podrá́ solicitar en cualquier momento la presentación de los equipos a efecto de validar las condiciones y el buen uso del mismo y en caso de que no se cumpla la presentación a revisión del equipo o éste presente algún daño se deberá tratar según lo indicado el departamento de Sistemas, la gerencia correspondiente y el área de Recursos Humanos y el departamento Legal. \n\nFinalmente, este documento fungirá como pagaré ejecutable sin restricción alguna para la empresa en caso de robo o sustracción ilegal por parte del signatario. Este documento sustentará un valor el cual lo determinara  RH según las características del equipo asignado , suma que el signatario deberá pagar en caso de `,
              alignment: 'justify',
              style: 'textStyle',
            },
            {
              text: `robo o abandono `,
              bold: true,
              alignment: 'justify',
              fontSize: 8,
              style: 'textStyle',
            },
            {
              text: `del equipo asignado. \n\n`,
              alignment: 'justify',
              fontSize: 8,
              style: 'textStyle',
            },
          ],
          style: {
            textStyle: {
              margin: [0, 10, 0, 0],
            },
          },
        },
        {
          margin: [0, 10, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 8 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 8 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 8 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 8 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 8 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
          //"pageBreak": "after"
        },
        {
          text: [
            {
              text: `TABLA DE RESPONSABILIDADES Y PORCENTAJE DE PARTICIPACIÓN EN CASO DE ROBO, EXTRAVÍO O DAÑO PARCIAL O TOTAL DE EQUIPO DE CÓMPUTO (SE HARÁ UNA VALORACIÓN PERTINENTE DE ACUERDO A LA SITUACIÓN).`,
              alignment: 'justify',
              fontSize: 7,
            },
          ],
          style: 'textStyle',
        },
        {
          margin: [0, 10, 0, 0],
          table: {
            headerRows: 1,
            widths: [165, 165, 165, 165, 90],
            body: [
              [
                {
                  text: 'Dentro del horario de trabajo y relacionado con este.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'En caso de que el trabajador no tenga responsabilidad por el robo o daño total o parcial.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'La empresa cubrirá el 100%.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
              ],
              [
                {
                  text: 'Fuera del horario laboral, pero relacionado con el trabajo.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'En caso de que el trabajador no tenga responsabilidad por el robo o daño total o parcial.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'La empresa cubrirá el 50% y el empleado el otro 50%.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
              ],
              [
                {
                  text: 'Fuera del horario de trabajo y no relacionado con sus actividades laborales.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'En caso de que el trabajador tenga o no responsabilidad por el robo o daño total o parcial.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'El empleado cubrirá el 100%.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
              ],
              [
                {
                  text: 'Fuera o dentro del horario de trabajo. ',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'Por robo, extravío, o daño parcial o total producido por negligencia y/o mal uso del trabajador.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
                {
                  text: 'El empleado cubrirá el 100% del valor comercial total del equipo.',
                  style: 'tableRow',
                  bold: true,
                  fontSize: 7,
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 42, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Recibe \n\n${record.name} ${record.lastname}`,
                      style: 'textStyle',
                      fontSize: 8,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Entrega TI`,
                      style: 'textStyle',
                      fontSize: 8,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'right',
                },
              ],
              [
                {
                  colSpan: 3,
                  text: '\n\n\n\n',
                  border: [false, false, false, false],
                  alignment: 'left',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 9,
          margin: [0, 20, 0, 0],
        },

        tableRow: {
          color: '#45535b',
          fontSize: 7,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 7,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options);
  } else if (subcompany.id === '611d4d8d39e15e0020534f71') {
    //Círculo de Crédito

    let imgEmployee = null;

    if (record.imgUrl !== undefined) {
      imgEmployee = await requestDownloadFileToConverBase64(record.imgUrl).payload;
    } else {
      imgEmployee = NotPicture;
    }

    const header = await generateHeaderCirculoDeCredito({
      width: '*',
      text: `Fecha de Expedición Doc: ${moment().format('DD/MM/YYYY')}`,
      style: 'textStyle',
      alignment: 'right',
    });

    var docDefinition = {
      content: [
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: `Carta responsiva de asignación de activos para colaboradores y proveedores de \nCírculo de Crédito (en adelante Círculo).`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
          ],
        },
        {
          margin: [0, 45, 0, 0],
          text: 'Recibí los bienes descritos en buenas condiciones de operación y servicio responsabilizándome de su uso y cuidado.\n\nRESPONSABILIDADES Y OBLIGACIONES DEL USUARIO: \n\n',
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 0, 0, 0],
          text: [
            {
              text: 'A) Generales y cuidado de los activos:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Firmar la presente carta responsiva de conformidad con las asignaciones.\n• Devolver los activos en el momento en que le sea(n) solicitado(s) ya que son propiedad de Círculo.\n• Dar buen uso del activo.\n• Utilizar el o los activos exclusivamente para las actividades relacionadas con la función para la cual ha sido contratado.\n• En caso de los activos que lo ameriten, no beber o comer cerca de ellos para evitar incidentes.\n• No podrá reasignar los activos que tiene bajo su resguardo sin tener la debida autorización por escrito de los responsables de Activo fijo de lo contrario seguirá siendo responsable de éstos.\n• Los activos podrán salir de la empresa siempre y cuando éste se encuentre autorizado para salida y en concordancia con las políticas correspondientes al activo.\n• Los activos asignados no deben ser desatendidos en lugares públicos, en los activos que lo ameriten deben transportarse como equipaje de mano y disimularlos en lo posible durante el viaje o trayecto.\n• En caso de robo o extravío de algún activo, se debe levantar un acta por robo o extravió en el ministerio público y entregarla al encargado de activo fijo para su reemplazo bajo el procedimiento correspondiente.\n• En caso de daño físico al activo debe dar aviso al encargado de activo fijo para realizar el procedimiento correspondiente.\n• Los activos tienen tiempo de uso y se reemplazan cada determinado tiempo, pudiéndose ofrecer al usuario al finalizar la vida útil para compra con un costo preferencial, de acuerdo con los lineamientos del área de Administración y Finanzas.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'B) De la seguridad de los activos.',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• No se encuentra autorizado para realizar cambios en la configuración establecida en los activos.\n• No se podrán instalar programas ajenos a los autorizados y licenciados por Círculo o la sustracción o adición de componentes, contraviniendo las políticas establecidas por la Dirección de Seguridad de la Información.\n• Proteger la información contenida en estos dispositivos de accesos no autorizados, modificación, divulgación y/o destrucción, así como hacer buen uso de la información.\n• Acceder solo a información a la que estoy expresamente autorizado para el desempeño de mis funciones.\n• Asumir solo los roles y privilegios para los que he sido autorizado.\n• Reportar inmediatamente todos los incidentes de seguridad amenazas potenciales y vulnerabilidades que llegase a encontrar dentro del equipo a la dirección de Seguridad de la información.\n• Siempre que sea posible debe eliminar información confidencial de los activos.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 80, 0, 0],
          text: [
            {
              text: 'C) Accesos, Identificadores de Usuario y Contraseñas:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Los identificadores de usuario (user-id) y contraseñas (password) asignadas para el acceso a los sistemas, aplicaciones y recursos de Círculo son personales, intransferibles y confidenciales. El titular de estas será responsable por su uso, así como de la información y provecho que a través de ellas obtenga, para sí o para terceros, y de los daños y perjuicios que se ocasionen sin menoscabo de las responsabilidades y sanciones de naturaleza civil y penal que resulten.\n• Círculo podrá dar de baja los accesos en el activo en el momento que la empresa lo encuentre conveniente, sin necesidad de dar aviso al usuario.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'D) Comportamiento Prohibido:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Está prohibido el uso de la infraestructura de sistemas, aplicaciones y recursos de Círculo para introducir o traficar con material obsceno, lujurioso o pornográfico; almacenar y/o solicitar mensajes o imágenes con orientación sexual; o provocar disgustos, ofensas y daño moral, incluyendo, pero no limitado a: hostigamiento basado en raza, nacionalidad, sexo, orientación sexual, edad, religión, defecto físico o creencias políticas.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'E) Sanciones:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• En caso de incumplir cualquiera de las responsabilidades el usuario podrá ser acreedor a un acta administrativa, retiro de activo, cobro del activo de acuerdo con el costo indicado por el área de Administración y Finanzas a la fecha del evento, y/o recisión de contrato.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'F)	Baja de empleado:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Al momento que el usuario cause baja de la empresa debera firmar este mismo documento en el apartado de entrega como evidencia de los activos regresados.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: [120, '*'],
            body: [
              [
                {
                  image: `data:image/png;base64,${imgEmployee}`,
                  width: 89,
                  height: 120,
                  alignment: 'center',
                  margin: [5, 5, 5, 5],
                },
                {
                  stack: [
                    {
                      text: 'Información del Empleado',
                      style: 'header',
                      alignment: 'left',
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: `Número de empleado: ${record.key}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Nombre: ${record.name} ${record.lastname}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Puesto: ${record.position}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Email: ${record.email}`,
                      style: 'tableRow',
                    },
                  ],
                  alignment: 'left',
                  border: [true, true, true, true],
                  fillColor: '#f9f9f9',
                  margin: [5, 5, 5, 5],
                  padding: [10, 10, 10, 10],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
            vLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            tableRow: {
              fontSize: 12,
              margin: [0, 5, 0, 5],
            },
          },
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          pageBreak: 'after',
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  border: [false, false, false, false],
                  text: [
                    {
                      text: 'Recepción de activos:',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
              ],
            ],
          },
        },
        {
          margin: [0, 50, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                signedDateCell(
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, true, false, false],
                    text: [
                      {
                        text: 'Fecha\n\n\n\n\n\n\n\n',
                        style: 'textStyle',
                        fontSize: 10,
                        bold: false,
                        alignment: 'center',
                      },
                      {
                        text: 'Entrega de activos:',
                        style: 'textStyle',
                        fontSize: 10,
                        bold: true,
                        alignment: 'center',
                      },
                    ],
                    alignment: 'left',
                  },
                  options.signature
                ),
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                signedCell(
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, true, false, false],
                    text: [
                      {
                        text: `Nombre y Firma del usuario responsable de los activos. \n\n${record.name} ${record.lastname}`,
                        style: 'textStyle',
                        fontSize: 10,
                        bold: false,
                        alignment: 'center',
                      },
                    ],
                    alignment: 'right',
                  },
                  options.signature
                ),
              ],
              [
                {
                  colSpan: 3,
                  text: '\n\n',
                  border: [false, false, false, false],
                  alignment: 'left',
                },
              ],
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: 'Fecha',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: false,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Nombre y Firma del usuario que entrega los activos.`,
                      style: 'textStyle',
                      fontSize: 10,
                      bold: false,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'right',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return {
          margin: [30, -30, 30, 0],
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                {
                  text: 'INFORMACIÓN PROPIEDAD DE CÍRCULO DE CRÉDITO\nPROHIBIDA SU REPRODUCCIÓN PARCIAL O TOTAL',
                  style: 'footerText',
                  alignment: 'center',
                  border: [true, true, true, true],
                },
                {
                  text: 'Código: AF-04-0005',
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, true, true, true],
                },
                {
                  text: 'Fecha de Emisión: 11-08-2016\nFecha de Actualización: 15-08-2024',
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, true, true, true],
                },
              ],
              [
                {
                  text: 'Uso Interno',
                  style: 'footerText',
                  alignment: 'center',
                  bold: true,
                  fontSize: 10,
                  alignment: 'center',
                  border: [true, false, true, true],
                },
                {
                  text: 'Versión: 4.0',
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, false, true, true],
                },
                {
                  text: `Página ${currentPage} de ${pageCount}`,
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, false, true, true],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === 2 ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              return '#ccc';
            },
            vLineColor: function (i, node) {
              return '#ccc';
            },
          },
          styles: {
            footerText: {
              color: '#45535b',
              fontSize: 7,
              margin: [5, 2, 5, 2],
            },
          },
        };
      },
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },
        footerText: {
          color: '#45535b',
          fontSize: 6.5,
          margin: [5, 2, 5, 2],
        },
        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options, { inBlock: true });
  } else if (subcompany.id === '6226793be2d6650028b55175') {
    //Círculo Laboral

    let imgEmployee = null;

    if (record.imgUrl !== undefined) {
      imgEmployee = await requestDownloadFileToConverBase64(record.imgUrl).payload;
    } else {
      imgEmployee = NotPicture;
    }

    const header = await generateHeaderCirculoLaboral({
      width: '*',
      text: `Fecha de Expedición Doc: ${moment().format('DD/MM/YYYY')}`,
      style: 'textStyle',
      alignment: 'right',
    });

    var docDefinition = {
      content: [
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: `Carta responsiva de asignación de activos para colaboradores y proveedores de \nCírculo Laboral (en adelante Círculo).`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
          ],
        },
        {
          margin: [0, 45, 0, 0],
          text: 'Recibí los bienes descritos en buenas condiciones de operación y servicio responsabilizándome de su uso y cuidado.\n\nRESPONSABILIDADES Y OBLIGACIONES DEL USUARIO: \n\n',
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 0, 0, 0],
          text: [
            {
              text: 'A) Generales y cuidado de los activos:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Firmar la presente carta responsiva de conformidad con las asignaciones.\n• Devolver los activos en el momento en que le sea(n) solicitado(s) ya que son propiedad de Círculo.\n• Dar buen uso del activo.\n• Utilizar el o los activos exclusivamente para las actividades relacionadas con la función para la cual ha sido contratado.\n• En caso de los activos que lo ameriten, no beber o comer cerca de ellos para evitar incidentes.\n• No podrá reasignar los activos que tiene bajo su resguardo sin tener la debida autorización por escrito de los responsables de Activo fijo de lo contrario seguirá siendo responsable de éstos.\n• Los activos podrán salir de la empresa siempre y cuando éste se encuentre autorizado para salida y en concordancia con las políticas correspondientes al activo.\n• Los activos asignados no deben ser desatendidos en lugares públicos, en los activos que lo ameriten deben transportarse como equipaje de mano y disimularlos en lo posible durante el viaje o trayecto.\n• En caso de robo o extravío de algún activo, se debe levantar un acta por robo o extravió en el ministerio público y entregarla al encargado de activo fijo para su reemplazo bajo el procedimiento correspondiente.\n• En caso de daño físico al activo debe dar aviso al encargado de activo fijo para realizar el procedimiento correspondiente.\n• Los activos tienen tiempo de uso y se reemplazan cada determinado tiempo, pudiéndose ofrecer al usuario al finalizar la vida útil para compra con un costo preferencial, de acuerdo con los lineamientos del área de Administración y Finanzas.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'B) De la seguridad de los activos.',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• No se encuentra autorizado para realizar cambios en la configuración establecida en los activos.\n• No se podrán instalar programas ajenos a los autorizados y licenciados por Círculo o la sustracción o adición de componentes, contraviniendo las políticas establecidas por la Dirección de Seguridad de la Información.\n• Proteger la información contenida en estos dispositivos de accesos no autorizados, modificación, divulgación y/o destrucción, así como hacer buen uso de la información.\n• Acceder solo a información a la que estoy expresamente autorizado para el desempeño de mis funciones.\n• Asumir solo los roles y privilegios para los que he sido autorizado.\n• Reportar inmediatamente todos los incidentes de seguridad amenazas potenciales y vulnerabilidades que llegase a encontrar dentro del equipo a la dirección de Seguridad de la información.\n• Siempre que sea posible debe eliminar información confidencial de los activos.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 80, 0, 0],
          text: [
            {
              text: 'C) Accesos, Identificadores de Usuario y Contraseñas:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Los identificadores de usuario (user-id) y contraseñas (password) asignadas para el acceso a los sistemas, aplicaciones y recursos de Círculo son personales, intransferibles y confidenciales. El titular de estas será responsable por su uso, así como de la información y provecho que a través de ellas obtenga, para sí o para terceros, y de los daños y perjuicios que se ocasionen sin menoscabo de las responsabilidades y sanciones de naturaleza civil y penal que resulten.\n• Círculo podrá dar de baja los accesos en el activo en el momento que la empresa lo encuentre conveniente, sin necesidad de dar aviso al usuario.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'D) Comportamiento Prohibido:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Está prohibido el uso de la infraestructura de sistemas, aplicaciones y recursos de Círculo para introducir o traficar con material obsceno, lujurioso o pornográfico; almacenar y/o solicitar mensajes o imágenes con orientación sexual; o provocar disgustos, ofensas y daño moral, incluyendo, pero no limitado a: hostigamiento basado en raza, nacionalidad, sexo, orientación sexual, edad, religión, defecto físico o creencias políticas.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'E) Sanciones:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• En caso de incumplir cualquiera de las responsabilidades el usuario podrá ser acreedor a un acta administrativa, retiro de activo, cobro del activo de acuerdo con el costo indicado por el área de Administración y Finanzas a la fecha del evento, y/o recisión de contrato.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: 'F)	Baja de empleado:',
              bold: true,
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 10, 0, 0],
          text: `• Al momento que el usuario cause baja de la empresa debera firmar este mismo documento en el apartado de entrega como evidencia de los activos regresados.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: [120, '*'],
            body: [
              [
                {
                  image: `data:image/png;base64,${imgEmployee}`,
                  width: 89,
                  height: 120,
                  alignment: 'center',
                  margin: [5, 5, 5, 5],
                },
                {
                  stack: [
                    {
                      text: 'Información del Empleado',
                      style: 'header',
                      alignment: 'left',
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: `Número de empleado: ${record.key}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Nombre: ${record.name} ${record.lastname}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Puesto: ${record.position}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Email: ${record.email}`,
                      style: 'tableRow',
                    },
                  ],
                  alignment: 'left',
                  border: [true, true, true, true],
                  fillColor: '#f9f9f9',
                  margin: [5, 5, 5, 5],
                  padding: [10, 10, 10, 10],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
            vLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            tableRow: {
              fontSize: 12,
              margin: [0, 5, 0, 5],
            },
          },
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          pageBreak: 'after',
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  border: [false, false, false, false],
                  text: [
                    {
                      text: 'Recepción de activos:',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
              ],
            ],
          },
        },
        {
          margin: [0, 50, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                signedDateCell(
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, true, false, false],
                    text: [
                      {
                        text: 'Fecha\n\n\n\n\n\n\n\n',
                        style: 'textStyle',
                        fontSize: 10,
                        bold: false,
                        alignment: 'center',
                      },
                      {
                        text: 'Entrega de activos:',
                        style: 'textStyle',
                        fontSize: 10,
                        bold: true,
                        alignment: 'center',
                      },
                    ],
                    alignment: 'left',
                  },
                  options.signature
                ),
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                signedCell(
                  {
                    margin: [0, 0, 0, 20],
                    border: [false, true, false, false],
                    text: [
                      {
                        text: `Nombre y Firma del usuario responsable de los activos. \n\n${record.name} ${record.lastname}`,
                        style: 'textStyle',
                        fontSize: 10,
                        bold: false,
                        alignment: 'center',
                      },
                    ],
                    alignment: 'right',
                  },
                  options.signature
                ),
              ],
              [
                {
                  colSpan: 3,
                  text: '\n\n',
                  border: [false, false, false, false],
                  alignment: 'left',
                },
              ],
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: 'Fecha',
                      style: 'textStyle',
                      fontSize: 10,
                      bold: false,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Nombre y Firma del usuario que entrega los activos.`,
                      style: 'textStyle',
                      fontSize: 10,
                      bold: false,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'right',
                },
              ],
            ],
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return {
          margin: [30, -30, 30, 0],
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                {
                  text: 'INFORMACIÓN PROPIEDAD DE CÍRCULO LABORAL PROHIBIDA SU REPRODUCCIÓN PARCIAL O TOTAL',
                  style: 'footerText',
                  alignment: 'center',
                  border: [true, true, true, true],
                },
                {
                  text: 'Código: CL-AF-04-0002',
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, true, true, true],
                },
                {
                  text: 'Fecha de Emisión:  18-08-2023\nFecha de Actualización:  15-08-2024',
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, true, true, true],
                },
              ],
              [
                {
                  text: 'Uso Interno',
                  style: 'footerText',
                  alignment: 'center',
                  bold: true,
                  fontSize: 10,
                  alignment: 'center',
                  border: [true, false, true, true],
                },
                {
                  text: 'Versión: 2.0',
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, false, true, true],
                },
                {
                  text: `Página ${currentPage} de ${pageCount}`,
                  style: 'footerText',
                  alignment: 'center',
                  border: [false, false, true, true],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === 2 ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              return '#ccc';
            },
            vLineColor: function (i, node) {
              return '#ccc';
            },
          },
          styles: {
            footerText: {
              color: '#45535b',
              fontSize: 7,
              margin: [5, 2, 5, 2],
            },
          },
        };
      },
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },
        footerText: {
          color: '#45535b',
          fontSize: 6.5,
          margin: [5, 2, 5, 2],
        },
        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options, { inBlock: true });
  } else if (subcompany.id === '66be330413d551004bec9270') {
    //Registro Único de Vivienda (RUV) Mobiliario

    let imgEmployee = null;

    if (record.imgUrl !== undefined) {
      imgEmployee = await requestDownloadFileToConverBase64(record.imgUrl).payload;
    } else {
      imgEmployee = NotPicture;
    }

    const header = await generateHeaderRUV({
      with: '*',
      text: `Fecha de Expedición Doc: ${moment().format('DD/MM/YYYY')}`,
      style: 'textStyle',
      alignment: 'right',
    });

    var docDefinition = {
      content: [
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              with: '*',
              text: `RUV - Gerencia de Administración y Finanzas\n\n Vale de Resguardo`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
          ],
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: [120, '*'],
            body: [
              [
                {
                  image: `data:image/png;base64,${imgEmployee}`,
                  width: 89,
                  height: 120,
                  alignment: 'center',
                  margin: [5, 5, 5, 5],
                },
                {
                  stack: [
                    {
                      text: 'Información del Empleado',
                      style: 'header',
                      alignment: 'left',
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: `Número de empleado: ${record.key}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Nombre: ${record.name} ${record.lastname}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Puesto: ${record.position}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Email: ${record.email}`,
                      style: 'tableRow',
                    },
                  ],
                  alignment: 'left',
                  border: [true, true, true, true],
                  fillColor: '#f9f9f9',
                  margin: [5, 5, 5, 5],
                  padding: [10, 10, 10, 10],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
            vLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            tableRow: {
              fontSize: 12,
              margin: [0, 5, 0, 5],
            },
          },
        },
        {
          margin: [0, 25, 0, 0],
          text: 'Recibí el equipo que se menciona a continuación:\n\n',
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 25, 0, 0],
          text: `El cual me comprometo a cuidar, mantener en buen estado y utilizar única y exclusivamente para asuntos
                relacionados con mi actividad laboral. En caso de su extravío, daño o uso inadecuado, me responsabilizo
                a pagar el costo de reparación o la reposición del equipo.`,
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [0, 42, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `${record.name} ${record.lastname}\n\n Recibe`,
                      style: 'textStyle',
                      fontSize: 8,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Representante de la Gerencia de\n\n Administración y Finanzas\n\n Entrega`,
                      style: 'textStyle',
                      fontSize: 8,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'right',
                },
              ],
              [
                {
                  colSpan: 3,
                  text: '\n\n\n\n',
                  border: [false, false, false, false],
                  alignment: 'left',
                },
              ],
            ],
          },
          layout: {
            hLineinline: function (i, node) {
              return 1;
            },
            vLineinline: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return {
          margin: [17, -15, 30, 0],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  image:
                    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABPsAAABrCAYAAAABzYdnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAACdOSURBVHhe7Z1Jk2RHuab1Z+APIIY1YBht1ktoIWTXetPGZGyZh53EDItuYwb1inlYMoP1XVxmWDLDEjFJi0ubSQIUXU+o3uq3XO6RkVmZVZmnnsfM5cenzz8f4sTxt06k7tmJiIiIiIiIiIjIJlDsExERERERERER2QiKfSIiIiIiIiIiIhtBsU9ERERERERERGQjKPaJiIiIiIiIiIhsBMU+ERERERERERGRjaDYJyIiIiIiIiIishEU++4CvvWtb+3e9KY37V71qlft49/97nfXS0REROQsfPvb39797W9/u54SEREREbk8KPZtnI997GO75zznObtnPetZNwLpL3zhC9driIiIyLH89Kc/3b3nPe/Zvfvd79799re/3T311FPXS0TksvDoo49evzp/fv/73+/vA//617+u55yexx577JZtiIiIHEKxb8PwRh/CHoG3+jiYvPzlL9+nX/SiF/mGn9x18Jn4yU9+cj21fTjsMN7zPvRc1XnknneauWCMd/o+Sf930569CvBG30rk4/DOml1FARAB4yIFkkPQ98c//vHdj3/8Y8VTORe+853v7F7zmtfs/vznP5/7nnr/+9+/+8Y3vnFLQh17/q1vfevu17/+tXteLgUI0OxLvsN4a30L+/JnP/vZ/vtaUV3uVhT7NgziHm/yIfTlAZ4bOEIf+ad9u+8yHHxvBxd92GEOEUu2LDwxhxnjbM8w7tn4e24SznOOeBuHt11vNz3es+yvs+4Z6r75zW/eP+icF/iPTe4ft/ogmHkh3I57yxe/+MX9+h/rN/vlPMZ5K+Az9/I78XNRhKuT1of90Ot42rXsvX2aee5249x02cwXfEawm7U9hrSfCX7vfe97d5///Ofv6J6Zgc+9nuO4KX/LW96y+81vfnPbfWcu+awxbxf1piQH2Kw5+zV99F5I2WxPpP1YNuYnPR4sEZ7OstfkbLzvfe/b/9maj370o7v77rtv96tf/erc9hVryef8L3/5y95m760ERGv2QN7eG8uzP2LrH//4xz49QnvqdNtuH6jHXp6Nsf3761//+ow6J5UfQ48zYw+z+Rk/511nHJvcHj7wgQ/sXv3qV++e+9zn7l74whfuz4oPPvjghYjlZ+XQPp9BfcaFMP/Pf/7zeq7I3YVi34ZB5EPU44Gnydt9pxU9OHDeCaHkdsLBkPniy+Qi4EEG+8wjIsJVnlPmCN8ZQ5M5pCwh0Ib6GXfizDfXtGVu0pbD11WBsWdMeRjhbZUeL+E0hz7movcM1+yjY8h+u2yHTNa75yVzg78X+VB5FrHvon06iYh9t9uHcX3YR7O3rlhL3p7hUN11jxG8ONwhHNMmfXWb3ie9hzlURrhP25Rjs8tGv/mMps+Un1YMpw8ORe9617tuOpji72UU+zhII+T1GjFnPS+pcyfEPvq+yD7HPZG9xtrR92tf+9r93HB/pR7l3/zmN29a20984hP7Nf/c5z53Uz6iEvk/+tGP9mOIvX7r60tf+tJ+zyEOycXD5/AFL3jB/jn3oYce2q81878S1E4D4gFr3uv75S9/ef/ZYW9wv6I/9gPlvFXEfvjIRz6yvy9QThzhYWavmbUf92ZspM9m9I393W8SYp97Vu4NlEfEXBGBMj6z5+mfzw0+pr+M8VOf+tR+/mfzA9jL/Yn+iU/yQc4P9s8DDzyw/6ywfuw3zo/sOdbqFa94xe773//+dH/ebr7yla/s79On+Sy/853v3H39619X7JO7FsW+DcNNGrGPf51BMOEBiJtk3uw7VjAI2KN9wB4BOEARRihPWepC8ptZnaTHstgk4BO+hdgmjCSPOpmTwHXEEeKx/axNIC99zsqB/NgOsRlip1ml098M7MSPk+odKl+ReeLhjjh9EZPX+6RJu0C/pDMH41qehtmYkw6rvIQR6qZsbNdQhu+MPSHiA/ndlofZ1fyMMC/MT4sRoy+HfKQ9voxixqE2pJO3qjPmcZ26hJPggb/nCMa2XM/6aLrfrtt0+UzsSzlhhLViz6b+zIfYDilP3ZVf5K/uJ80o9sUuEM/6IJ281DkN9MnhbFyfma/kUbf3GGIceTNxMGCv62CHAx8HWdIRaBg7n4G2xUGTz1Cns670zbymLGPJQWVsm8Nn0seA8IMN/BvfUME+BybyOASPc0aasVOe64TRB8oTKCcO2GacvUYzaBOf+rAWAYo3eSD1EPtm/QHp5I1jS5vZOID6lOEza8L8xZ9u2zaBdPJiY2Z/BW16X0H6I53yFuIiPkTAA+Yr+zGHRtoyZ+S1AJP21KMvfqrZtuRiYc7vv//+3b333ntD8Duvn8qy5qxnv+2EoMbemAkQiGlj/RHacx+aiRER4w6JX6s+4usPf/jDG3vzk5/85P5+l774OTL3hqTH8gZ73PsYK/eOCHrkc79OH6Tf9ra33eg345vND0JT1yV9Hj+RluN5xzvesRdY2T8Is+wH7mesGZ8b1vZ1r3vd7vHHH7/e4jCsIZ9B9uIf/vCH/b12tpbUY69QzvdY792ZDQJ7A1+5n/ZbqF1ntPXBD35wv59mexpom72HP+N1oF5s93WYtQmnHWts9Lj4XuHzx1vKYx/jGLqP0SaM/h/yXa4+in0bhg83Dzr5G32EpHm7j5vLaeABgBA4BPOQy0N7DmSUxy4x+QmUR+jCN9LEgTptP3bJo24OxqTbJunYpU7K0rbHSR52YyN2IePptoE21E0Z6UD7LiPM5pY86sXXGfTZ/TI//Atb5inzlrlpP5ouJ6ZN24Vj/R6hDnbxJTbSLvNPOqHJHAfKaZ81GMd/GmI7Y05oH3hIzZyRT19dN2XA+LqMkHUYiS3K4wdfpDPwgbr9Zb+i/Z1Bfz0G5hJRJOALee0LbbCbNoQWarKGPY/00TZo3/s44l3XX42P/nkTZhQgRzL22MEvDhjxg3SPYxw7ICqQT3nG0zYjpKX9OE76a5Eg40yasVAn/bIP8Ak7WRfstg0Y54u57PImPqY842Yc9JHxtd+0oSxjpk4EqJNgDOO4D5E5GNdzFFhGIuZ1efwmj2vGmv0a+7P+Ii7OHlS77FDbiF4nwQMxY0MUYx17PzF3LfbxYM78t1/kMUbyGGP2MGvEIabXMXUJ1MHvtptw0jzPxoevvUaMK763T/2mX9aMOthM2/QRfyjPmDMnKcs4x35TTug+WZ/0Gb8Ix65Xz/cM7DMP41t3vKnU7bDDWuND/OPwRZp6jGccM3nskUP9y8XA+vFzxIh95/FWH8yEvVsV69hHqzrHiIUrcYzP1ti2xbxZ+Um+cM/is4cdPpOzMSMctICHgESfszVIf112qL6cL9/97nf3Qt4TTzyxf2uOexv3RO7pfN+wzqxDBMFj1gQ7rCliMDHfDbwl2PsMsYl92/f9FrHYa3yGYyNvhXKv5o166md/MQbqxE6ES/piLx76GW/K0w/tmYuf//zn+z38y1/+ct9H12MOPv3pT+/36JNPPnnd0m6aB7Ox/uAHP7jhD31FxOTeQh/Y+N73vrf3gfEyh8SUze4FH/rQh/bt+UxmHPTBP1JlDXg7kz4ZCwIo9Rlr2qdf2R6KfRuHB+uIfR1zQzottOFhN3AQw34O/TzgkiYfqEs6cNAi5JqypGG0H6GiRQXKuYnRF1BGGsjjuv0h3Tbpg7z0mz5C/Ip9yDhXvo99UL/bN+mP+rN6+NdrM/aVNHVWfUD6yVys7KQcGMdJdkcyN2mDPWxknUabxMmjLfVm65N86hxLfMmY6IsvuNF+yompn8M1c5L5WbXFt4xlBW2o14f2QFu+zHveV8SHQ3Vz0IxPGVPEDOYEX5LuceVhIcJT/KVN15n5MY4h/QNzSP1ReAvxseeH9m0D6KP9jF9ju8AhhHGM9eMHfo02T+pzTEeM6j0zjpU2XYc2Pd741WtEm6RHMq6xT/xK3ugnD+oIqvhFXtqs+mhOUxeYw8xB+u95Sd7IuF6QvD60jv7MxLlDPmfNVvNw2vEyt3xm8DHiV/vLgzUP3PQXYTC+MleUR+jq/cd1i2+A7/jW8xihLzYzH6u5Tv32MbQQlv45AKTurC9+st1iXsYYASziXfzJG3GxQXrss+2t+uSwhr20OfZNOQ6MbX9k9D/E7xzIsBPxLsIevnLNZy9jCviN3R6L3D7YJy996UtvPPd+7WtfW+6B0zAT9hCsWGv2KJ/Z7A+IWMdBmn1CGfuh99ohQe+k9t2WMeNLjzPiJJ8X7ld8NiPkzfpN3klvQiJO8LmaCSixkb+TGB8yP9wb4mPEvvZhlicXAwIW93wELK6Zc+afdeo81pA9HnHoEIhvrD9iE+uMuPT2t799v4cjFqbfiEsIhNj/05/+tF9z9hBCFyLhKKix71p0xD57P3uFn+2mr4h0K7EPEL74Dn3kkUdu2BjFPqBe7KY8begHQbRFPCA/4nXG8dWvfnU/P2mLGMj89FixT94vfvGLff/UYRztY/Pwww/v5y/1k47AR598ptpf5oly7gt8v61sy9VHsW/jcJDkYWcU/LgxnhYeWnnYCBzayWtbpCMC5FCPD2N/HLAoIw7cDAkh9pvRh9jBPv2MNkcb7R+kTfwb0zD6BW2Ha0L3ewj6wB790I50yKEhjPM0pleMdhgP7dJX1qaZjf0kaMMY0oZ+sUFMXvztOaeMNpmDHj/1yCeOrW57iPjSX1bpK3k8cMZexkt6nM+URUyBY+cee6MfIf603RX0wwNIz0+zKievx0h6FJrGcZHHAzhQZ/Sx5w3GNNCOPALzFHsjPES2ffrHHm1Y+8wbByrmK+mV7+mXtm03/fQ6kNd9QPuN/e4z42yf2uY4d+x52vTYyes6lHcfadP9NOM48Jf64/q0zXGc7cOsjybiUds/RGzzAM4Y8IP0OM8js7XIWPNwDZnjiHFJt4ASn0dRpdeHfkZbMMs7RAtZjJ00bTvNXHSaAzrpmZ/k9f7rNWoxDrDHA/y4jvTR9RpssCarsrSLSNei1yiERcBq/yOKtf3uk0NNxg+xiY2ZvVmfo/2e00P0eszGD4fEvsxN7FAnYi8+k0fcdQNtGDv7uccntw9Ei+c///nnKvjNfuZKPxGBuYexnxAFqMP+4vPAHqScMkSOfnPukMCW9rHNZ4H26b/fsMMOe7KFkOSxD7m/xK+U0e8o9lH/0JuIsHqbEEYhMPNDHvcF5iBtIwS2zxH7Ok8uBgSq/P1ZYgQn9kmu+YeWvFlG3jE/5c2bdqNIx+eGPPYYQlmEPYjgFYEwdVpsg0Nvz7Fv+B6l7xYWW6QbiRg4ls/EvK6XNH8LkPRYP2RcPQ7aMu8R4mZ1Is61uHro7TvK4gukfdaLtwRHQS953BvGeZZtodh3F8DPQFvs44N9FrjBEgKHzrbFwy1pbraBa/IItOVgBcSjcEI5DwIhbRvKyaMvoA52SOMP1+mvQ+C6/Uub2Fv5NdqjTnylbfwi9BgOQTtsd3+kCWH0h5g+2r8Z+HDITvrJuIGy/snwMYzzN1uzzst16qd9r0nDOCg/9NAZYrvrZl3SH2PuvrKHCZRl7PFrFJYO+RrS5yiWxCbxMeAzD1ir/mJvFCm6DXVIpw7547jSDwICpE3PIw/jjCt5pNMH7Ukz5uw7+oi9kZUPmbfuo/uMX2lHuvsl7vYcLvClxzEKTBHvyIuN7jPjTDpiVNLsiZ67zMU49q4Tnzscmq+xz4y7549xtN/jOHuNk7eix3RSXRjXn4CPJ7UdxwWzN+Wwz+EweziCWe/7+Nx58avnZVWv7R8idTm0Mj/sDey18MQDNuVJZy0YU19ja9x/o62IZkmn/16b2IndEWzQx6qs/cH3k8S+cX0QuvCbPhLYz8wB9UYxMPU55GS9Z2Jf3txLn10nczwb08h5vNnH3CCKUCfzxDox79iNmNF9RABkPqh7jK9y/iCGPe95z9s/+xIi+LHu/HzxtP+X3tmbfSPsB/bU7M00+mUv9d/RO1ZggxboYisi4SiSjeWk+TxELGxb6Td5Z32zj7eY+NzMxh5a4IvPXX+WJxcDghX7gblmTYlzP2N9KOczwr362L/bh9jHd0uLUvlp70rsG8U06rBXxzcJZ2/25a1AxEnKuB5FudWbfSnn89jlJ73ZB/TLPDGmvm5mImCPlfrUYe57PsjrN/uSjkA4MhP78Cfzl58E//GPf7zJD97uQ8w99u8xytVEse8ugAMJ/0OOCH4ceM5CDiQBuzzIBh6CSZM/Qp+UYSNpDgS0CZSlHEb7kD4SsMHBEohJY5tA3cSBNqkPaZM6Yxpog19tL6Ehjc+0n83Biq4/zgE2MyYgHv2bwTodskM542p6/o5lnK/ZmrUvlPUegpkvAfuUnTReSN1+OIzt5PGAOVsbxoyPjIW6GVcLKpl7yg6RPse2HHBPajuCv+N8hdicCRwZY9ajBTLazHyL2JR57DrjvI19jHPV9kbiwyiuxNdxrZIefeeauely2qScBx3WNOXQItg4bqBN2xx9GAUqbFCnbYzpsZ/4hZ+UsWbEK8Y+x3EC6fa7xwn0MZvzGanbotMhMr5jbDcRerqP2ZqN9pNu8Se2MieMYWWLeu1rxMNj3r6iH+pyOMI2gbUhzoGAAw0HjvTbYhVl7APK0m+LTJSfVuwD2rUPTXwexxdb6Q8hgPQhsS/z3P1ETMQ+84vdBCDGP+okxP+Zb+mzxT7SfcAZ5+kQLWjOiH2ElqZFwviUOhlzyjkcMy/xsW2u7Mvtg0Nu/n4fz8BveMMb9gdcPsf33XffqQS/2ZtoI+yXUURr8KfFvohbx4h9bZt27K2MBb9yf+IzG8G6fZ2Jhe1nykfRYmQm9mVuVuMO8TvCz9iff7Pv9oFIxf99F1GIa+7NPGNwb+a+zDqzNohT7Ktj1mQmfHXeTOybvdnHPbjrwPhmX2ylHYyCICLdacU+BMux/1HsQ4BLHWyMP+GFQ2/28Q8P2Eqd8a3A/NyXzzffNxEHZxwj9uFr95G3/7DdbWV7KPbdJfDGFoIfh/Kzwg2WEPhC4CaRh3ogHRGgH/ghogB5HApaOCGPti1scN39Ae2oR5yDReAam+l/RvsH4xjiF3Fov0Nfd13A3ug30Ib+xrY9D+OY03f6IM74DzHaoc/uZ+wXaINtoD7pLp9Bec9N7LZ/2MQW4NM4Nz1ftOv5IT8+UUa6bTfxpct58EzfQPuk6af76vbk89DceyVr0SLLDOrhc+phj3TbCvSJPyeNiTjEb8I4Purhd8SMpFsEOWlctGn/If3kIYGHiNhI+5QxFvqIuDUDe6xFP9iMotbYZ8rj16y8/YiQ0GPvNvEzc5W5aZukW1QYfUwfGevYB4x+jOMA2q0Y+4zf3Z71GOei5zdji8iCAEGbttGkzxbF6Bc7BMrZJ9gabTeMvf1qep/EDnM3ijizdRrnmLH0eMd0w8PtobaMjT09azuKbxAhKIIY9lvsA/LogzmNsJV9kTTjws4hsQ9iKweH9D+bf8BufEobWPXffwsvYkHqsG86DRGzWiTEVkgbyrOHwmzMo1+zPjkApQ3jZ81W48/8dB/0iy9pT3mLcREjMhdjHeaFn7f1G1X4mIPeKDByyEqavmm/8lcuhvENP8KDDz64FzBYy5MEqsBeYP/1m2/kcS9NOqIX+4Wy7DWIuNXtZz8NDqPt7E3ak085nxHuj/m8sm8poy6f/RYR2zfyRtHukC8Ngly3Y1z0NXsjkLK+9+TtP8QFhI9R/ET4WP1EWM6f17/+9bvPfvaz+z3B2nCv5J7KdyPryf565StfedNbYYfIz3gjlPWbbFlz1riFs4h2EcVIHyP2zcS0/pt9SSNmZa8iPDJG0iuxL2/kxW76aTtpG6E9vtKWzyL3FO73PXbIW3YR3qg/vtmHbcbK54Dvzr4HADZYo8zDMT/jpc+sIeNBcCTNXDO2vEUo20Ox7y6BAwMPNzx0nBUOKtxkQw75gZsa6YgA9Jk2XHcZkE85ZVxTPtqnvMH/1KOc0EII6ZSn/y4n3T6kPr4H6hCwkcNJ/IuvBPIJqZsy0rN5johC6DFzHagz9kM69jL+mf0m7QP1x5/oxtf2JeX4wf+xuW3MiL89f9jLGDI3YZyDXKd96s98Yq0YQ69fE1/SHluk+ZIMfCFTBtjp/uJzyN6IL9Slj5OIrXwxc3CNnYSM4aQxMS+xl7bt5zhmrtsWc0f/lPc8xsZsXFzTph8sMm89pvSDXcqx0zaJ20ZzTJsc+rscv7OeYzmBcg7RwNzxsLrqg/LRh9RJH2kfm5lP6qdN9wmjTcpHoWHWb+/TJutBXWwk3fW7HHgIxGb32f/DDsZFusW8ZjV3tGcOaEsaW9Sl/9gOGSf7u4WaBj+xE/vtc6A/DuM88AYOH/RJ/bTNWLCJfzyAx3filB9qm/Ulb3zo5VDNIXs2TvKzxvQ/zkf7FLu042Gcvjg0xxfi1Jm9lYYfzCv5jCvXhx7SGTM+Zk6y/9rHjK/9YRwt/uUz14cixtFvutGO6xbrsEsZfXPfYL5jMwLFafpELKE+Y8Y++yPpGbHR48+cMW7ebBnnhvWMvYwhYh9jJi8+RoChnL66LqQ9e5jPL/72XpDbA0LXS17ykt2zn/3s/fMw/wDOW34tNB0DB/MWoxDIsoe5b7LXYjOCW5d1Ww71iBrs+ZkP+MzeQSygPf2shLD0lQN/bOezOfoGHPT5PLEf+UxgfybYjbRIiA1+4skbSOTxOaKviBTUjf1ZHxEgqZM4YqRcPOyTBx54YPfhD394v37cD/nezs9i77///v3PR2d7bkb+Bx1pn++5FrMi7mVfs8dbSEv5+LZb8mObfYKYhv3Yyh5Lf4hm2OfNO76XELl4LkMIY+ykx7fyyMcue5F+4iOiaD5fgHDI3v/MZz5zI583ALnHRzyL0EZb7OBbC3P5ie74U1/spH8+U9wj8DFlfJYj3p1G7OP7CwEUf1ospK/xZ9OyDRT77iJWgsKx8JBKCNwwRpukOTAB5dQnj9BtIe3TJiFwTdlI8rn5Ebhpd72UE8Y+yes+4gNxGP0K2KK/Vf2UdZuRtr2qm36IUz/9jekVtD1p7LAaExzTD/aoN4Jd8mc2MoYeY+B65RPXrPU4rkA+X/j4tBoTdXoOSMfPmd22Nc7dinFOug9C7KWMMa1ElxCbmbMmZYRDY+i5SB5tuG5IY6frj/Uo7zTX8Y92BNKHoA524sfMd/JSlvrtV7fngQc/2q/4QUhZ9zOWp49AGqGm86jXfXK4b594kItNQrcN6Sd2uv0M+ki9tO02pHvciAvk5cERsNFCKX6uBMaAnR5H+iQ//ZHXtpuZHyPYyRz3mMLKPu3iW5e1z5nfsU637XkDHpBpN/p87DhTD9uxgaBEXotc0HUpI42t9JF5XvmCn6P4uKLbjPMB6Zv+GAtrsvJ31h9taZOxdB3KyCdw2OGQ0oIe85O2o1+U4U/n97zgE4ewtjcja5A5i72MKf6tfKDO6rAbG5Tj22zPI8RkHO2/3F5YS8Rpfr7LP2g+9NBDNx3ejwHBgftEBCkO39n/iMQICr229ImoTdn42Zi9fTdCf9mjY/sGP7A37lPysrdn7bO/KR99X4FP7Gf6Sr/pg8BcIPbFVpfP+sAebfLZPMYHOT9YQ0RZPhcvfvGLd/fee+/uZS972e6Nb3zjqf+uZX6yi6CbfT9bc94uSzl7pfdt9lQLcKE/DylHYMyeY/9QJ33GFnuLPhDX+BykP9rOPn/4l31LOTa7HaRO+08e94P2PfXwkXkZxzrzofunHfeJCHKMgc9f+hjHNJbHFve6XHd/5CG6H/uGs1wtFPvkysADNTe9kfxroWwb1h4xb0XKr9IXFQdP9q5frtuAexQiGg+VlxkexGeC1t0OAgzrx0Oz3DoRwcZ9xqGF+14feM4K9lmz2aFQ5BAcss9yD6Qdb/Pxxs2t7DtEtvEnvSJ3EvZ2/sFiJgwfQ37Gu/r7cnIyvIk3in95A/DYn1OLBMU+uVLwFhSHhLx9QCCPg6tsG8Q81nsFZYh9HDCvCoyJvSzbgbeWLrvYh0DivnsmzAn/gu6D9PnAvZi37hBF+Ewwv+w9PiO8zXEe87x6k07kIokociuC9XnYELlsKPbdOg8//PD+H7H4eXHOuvk5fP8cWuQYFPvkSsFhAbEPUYfA9SEBSO4e2BvuBbmTIG6wB6+S4CxykfD2Em+S5vuagPDnYUVEZHvwk1CexxWxzw7/EMDPofPTXb43+Uczf2YrZ0GxT0REREREREREZCMo9omIiIiIiIiIiGwExT4REREREREREZGNoNgnIiIiIiIiIiKyERT7RERERERERERENoJin4iIiIiIiIiIyEZQ7BMREREREREREdkIin0iIiIiIiIiIiIbQbFPRERERERERERkIyj2iYiIiIiIiIiIbATFPhERERERERERkY2g2CciIiIiIiIiIrIRFPtEREREREREREQ2gmKfiIiIiIiIiIjIRlDsExERERERERER2Qj37B59dGe4YuEvf306XLt+8re/uTnfPPPMM888884rz2C4XSH7znA5Q3PV0o89tts99dT1xDVMmzZ9PXEN06bvZFoulHt2/+NVO8MVCy/7b0+Hf/vvT4fkcU1MOmXWs571rGc96521XpeZNn2RaWL2n+FyhWtr8/h//MfuP//x5O7RRx81GAwGg8FwCcNT18JjHT/11O6e/QPW9S/zmx64iA2XM7A+41rN1s4888wzzzzzbiWvnw8SOt9yy8+rnNhwKUOLfdf+s/v73/++j/eHiyeeeEb+ZSzn8DOW7w9D51Cew9VZyv9lueV3c/njj+8ee+yxffn/vZbfseXbLyfOXvD6dNdP1dzmms9WQr637rnpAYzAg9d4TdzXxnc+7kAeD2RdNtabtT/pelXe6VWd2fWqvNOrOrPrVXmnV3Vm16vyTq/qzK5X5Z1e1Zldr8o7vaozu16Vd3pVZ3a9Ku/0qs7selXe6VWd2fWqvNOrOrPrVXmnV3Vm16vyTq/qzK5X5Z1e1Zldr8o7vaozu16Vd3pVZ3a9Ku/0qs7selXe6VWd2fWqvNOrOrPrVXmnV3Vm16tyg+G8A/srzyxjnL1nfOdjAutyLTz+7/9nL/Zx0MghIgcK8vaHimuH+uRftvL94eg2lBOvyiN6WG655f+/HDFiX15iheV3T7nh7IF5ZH4RTzOn43wT3/xmX2K+6DuMebO65t3+vLGsw6reqt2s3qpce4frJ70q197h+kmvyrV3uH7Sq3LtHa6f9Kr8brVnbHwece+zDl0+1je+c/H1deg3+/YHimsHd66TJr72n5sPIdfrJN15l7E9h6Tzbs+hq9tH8Eh8qP0ojtje9ltvj2hxo/0gDnVeYttf/faz69halXv99HXi1Zwzj3zOnvlmH2F8OCOe1TNcrXCadTymrvbWQXvPDNpbB+09M2hvHe6EPYPhPAJ7bXy+JD6pTvKNb2/M/F8LebOvRa4Wvjhc9KFuVY/42n+ekX872+cAdNHtI2bkOgJH2rfwMbZvMaTr2d72m2v/+OPPbH9A2LjRvvLvdPsWuWx/XHvqEzrd17Q9VO71zXM9zjlrkutnin2zB6xZvvHVi3udTwon1dfe4aC9m4P2Dgft3Ry0dzjcbnsGw3kF9hrPJGP+Sc8viWPD+GLjYd4j9nF4uPaf/YEj18SEFr9m9XI9a8v1/hBzRNvzat8HJq67fdLj9THtybO97W1/uvaIE/v21wWhiBV9fdnb7wVM2x/VPuJU5+U6do6pezdfz9YgdXren/4Zr8FgMBgMBoPBYDB0+C//dff49767+88nnxbCcpjo68TX/rP70yOP7A9riVP+yJAm5nDd6YTRbuJr/7kpfdr2ORxdlvb7Q22lE2xv+1m8yfYl6iQc3b5EINIJtr987bttrilb5XfZIRt3+3XmZpZPYI3u2X3kY7vdw/97d2Ls9Z2/Tjrhf/6vs8er645neauy1XXHs7xV2eq641neqmx13fEsb1W2uu54lrcqW113PMtbla2uO57lrcpW1x3P8lZlq+uOZ3mrstV1x7O8VdnquuNZ3qpsdd3xLG9VtrrueJa3KltddzzLW5Wtrjue5a3KVtcdz/JWZavrjmd5q7LVdcezvFXZ6rrjWd6qbHXd8Ul1vfb6Vq6PiRP62cf4zsUVnvz1r278jHcV9oeNA/HquvNmwfa2P3Rte9snbxZutX3eWFtdd94s2P7mesTM+WhnvF6VjfEhG3fDdafH/JTdsxMRERERETkCDhGJ+7oZ8zs+qSwheR3Dqoy4Q/I6hlUZcYfkdQyrMuIOyesYVmXEHZLXMazKiDskr2NYlRF3SF7HsCoj7pC8jmFVRtwheR3Dqoy4Q/I6hlUZcYfkdQyrMuIOyesYVmXEHZLXMazKiDskr2NYlRF3SF7HsCoj7pC8jmFVRtwheR3Dqoy4Q/I6hlUZcYfkdQyrMuIOyesYVmXEHZLXMazKiDskr2NYlRF3SF7HsCojHkPyOw6dXl0fyyHbYYt1ku78sY5in4iIiIiIiIiIyEZQ7BMREREREREREdkIin0iIiIiIiIiIiIbQbFPRERERERERERkIyj2iYiIiIiIiIiIbATFPhERERERERERkY2g2CciIiIiIiIiIrIRFPtEREREREREREQ2gmKfiIiIiIiIiIjIRlDsExERERERERER2QiKfSIiIiIiIiIiIhtBsU9ERERERERERGQjKPaJiIiIiIiIiIhsBMU+ERERERERERGRjaDYJyIiIiIiIiIishEU+0RERERERERERDaCYp+IiIiIiIiIiMhGUOwTERERERERERHZCIp9IiIiIiIiIiIiG0GxT0REREREREREZCMo9omIiIiIiIiIiGwExT4REREREREREZGNoNgnIiIiIiIiIiKyERT7RERERERERERENoJin4iIiIiIiIiIyEZQ7BMREREREREREdkIin0iIiIiIiIiIiIbQbFPRERERERERERkIyj2iYiIiIiIiIiIbATFPhERERERERERkY2g2CciIiIiIiIiIrIRFPtEREREREREREQ2gmKfiIiIiIiIiIjIRlDsExERERERERER2QiKfSIiIiIiIiIiIhtBsU9ERERERERERGQjKPaJiIiIiIiIiIhsBMU+ERERERERERGRjaDYJyIiIiIiIiIishEU+0RERERERERERDaCYp+IiIiIiIiIiMhGUOwTERERERERERHZCIp9IiIiIiIiIiIiG0GxT0REREREREREZCMo9omIiIiIiIiIiGwExT4REREREREREZGNoNgnIiIiIiIiIiKyERT7RERERERERERENoJin4iIiIiIiIiIyEZQ7BMREREREREREdkIin0iIiIiIiIiIiIbQbFPRERERERERERkIyj2iYiIiIiIiIiIbATFPhERERERERERkY2g2CciIiIiIiIiIrIRFPtEREREREREREQ2gmKfiIiIiIiIiIjIRlDsExERERERERER2QS73f8DdcZU4tNwhN4AAAAASUVORK5CYII=',
                  width: 550,
                  height: 50,
                  alignment: 'center',
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
          },
        };
      },
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },
        footerText: {
          color: '#45535b',
          fontSize: 6.5,
          margin: [5, 2, 5, 2],
        },
        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options);
  } else if (subcompany.id === '66be19ce13d551004bec7f90') {
    //Registro Único de Vivienda (RUV) Tecnología

    let imgEmployee = null;

    if (record.imgUrl !== undefined) {
      imgEmployee = await requestDownloadFileToConverBase64(record.imgUrl).payload;
    } else {
      imgEmployee = NotPicture;
    }

    const header = await generateHeaderRUV({
      with: '*',
      text: `Fecha de Expedición Doc: ${moment().format('DD/MM/YYYY')}`,
      style: 'textStyle',
      alignment: 'right',
    });

    var docDefinition = {
      content: [
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              with: '*',
              text: `RUV - Gerencia de Infraestructura y Mantenimiento \n\n Vale de Resguardo`,
              bold: true,
              style: 'textStyle',
              alignment: 'center',
            },
          ],
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: [120, '*'],
            body: [
              [
                {
                  image: `data:image/png;base64,${imgEmployee}`,
                  width: 89,
                  height: 120,
                  alignment: 'center',
                  margin: [5, 5, 5, 5],
                },
                {
                  stack: [
                    {
                      text: 'Información del Empleado',
                      style: 'header',
                      alignment: 'left',
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: `Número de empleado: ${record.key}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Nombre: ${record.name} ${record.lastname}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Puesto: ${record.position}`,
                      style: 'tableRow',
                    },
                    {
                      text: `Email: ${record.email}`,
                      style: 'tableRow',
                    },
                  ],
                  alignment: 'left',
                  border: [true, true, true, true],
                  fillColor: '#f9f9f9',
                  margin: [5, 5, 5, 5],
                  padding: [10, 10, 10, 10],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
            vLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            tableRow: {
              fontSize: 12,
              margin: [0, 5, 0, 5],
            },
          },
        },
        {
          margin: [0, 25, 0, 0],
          text: 'Recibí el equipo que se menciona a continuación:\n\n',
          style: 'textStyle',
          bold: false,
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          margin: [0, 25, 0, 0],
          text: `Por este conducto acepta, reconoce y se compromete a que por motivo del contrato laboral que tiene celebrado con el Registro Único de Vivienda (RUV), a conducirse con responsabilidad, probidad y honradez, respecto del acceso que tiene a tecnología, documentos, datos, especificaciones, métodos, procesos y en general a información relacionada con los servicios que ofrece a el RUV y que es sabedor de que está es considerada información confidencial,  y por lo señalado se obliga a no divulgar, revelar, comunicar, transmitir, grabar, duplicar, copiar o de cualquier otra forma de reproducir, sin autorización expresa y por escrito del RUV, la información y documentación a que tiene acceso en virtud de que dicha información contribuye un secreto industrial en términos de lo previsto en la ley de la propiedad industrial.\n\nAsí mismo, manifiesta conocer las obligaciones derivadas de las políticas internas del RUV y consecuentemente se obliga a lo siguiente, respecto de los equipos de cómputo y electrónico de los que dispone para sus actividades, y que son propiedad del RUV:`,
          style: 'textStyle',
          alignment: 'justify',
          bold: false,
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '1.	Solicitar al personal de la Gerencia de Infraestructura y Mantenimiento la instalación de cualquier software que requiera para sus funciones, evitando instalar programas sin autorización.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '2.	Que el equipo de cómputo asignado, así como las plataformas tecnológicas, el software y la información que se genere derivada de sus actividades laborales son propiedad exclusiva del RUV.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '3.	Asumir la responsabilidad que resulte en caso de pérdida total o parcial de información o configuraciones de equipos o servidores utilizando las firmas proporcionadas por el RUV.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '4.	Coadyuvar y comparecer ante las autoridades competentes o la instancia que el RUV indique, para realizar las acciones que correspondan en caso de perdida, modificación o alteración de información en equipos de cómputo o servidores, lo cual no haya sido autorizada por personal de la Gerencia de Infraestructura y Mantenimiento del el RUV.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '5.	En el caso de que los equipos de cómputo y electrónicos asignados con motivo del cumplimiento de mis obligaciones laborales sufran afectaciones por motivos de desinterés, negligencia o descuido, así como que haya desperfectos, perdida de información o robo de la misma en los servidores,  infraestructura, enlaces de comunicación y operación de la empresa, autorizo a RUV, a llevar a cabo las medidas legales necesarias para que el daño sea resarcido y las responsabilidades deslindadas de acuerdo a la normatividad aplicable.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '6.	Utilizar el equipo de cómputo, herramientas electrónicas y las firmas de acceso que le sean asignadas exclusivamente para el desempeño de las actividades para las cuales ha sido contratado.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '7.	A no prestar o transferir a persona alguna los equipos de cómputo o electrónicos, así como las firmas asignadas para el desempeño de las actividades laborales.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '8.	No compartir la firma personalizada asignada y manifiesta su conformidad para que, en caso de incumplimiento de este principio, se impongan las medidas disciplinarias correspondientes.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '9.	Notificar por medio de un escrito dirigido a la Gerencia de Infraestructura y Mantenimiento cuando incurra en error o mal manejo del equipo de cómputo o electrónico, así como de las firmas y accesos asignados para el desempeño de las actividades laborales.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '10.	Conocer la vigencia de las firmas otorgadas, las cuales solo se utilizarán para realizar las actividades apegadas al contrato celebrado.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '11.	Aceptar que el conocimiento exclusivo e intransferible de las contraseñas y accesos otorgados para el manejo del equipo de cómputo, electrónico y de las firmas asignadas, y deslindar al personal del RUV por cualquier mal manejo de esta, a menos que se demuestre lo contrario con los medios probatorios idóneos en el caso concreto.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '12.	Comprender que es función de la Gerencia de Infraestructura y Mantenimiento proponer e instrumentar los esquemas de almacenamiento para la realización de respaldos de información por temas de seguridad informática.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [20, 20, 0, 0],
          text: [
            {
              text: '13.	El equipo se recibe en condiciones óptimas.',
            },
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 25, 0, 0],
          text: [
            'Suscribe la presente responsiva de manera voluntaria, la cual se encuentra libre de cualquier vicio del consentimiento que pudiera afectar de nulificar al presente instrumento, todo o en parte, por lo que firma de conformidad el día ',
            { text: moment().format('DD'), bold: true },
            ' del mes de ',
            { text: moment().format('MMMM'), bold: true },
            ' del año ',
            { text: moment().format('YYYY'), bold: true },
            '.\n',
          ],
          style: 'textStyle',
          alignment: 'justify',
        },
        {
          margin: [0, 25, 0, 0],
          stack: [
            {
              text: 'El usuario acepta haber leído y comprendido las Políticas de Seguridad Informática del Registro Único de Vivienda (consultable:',
              alignment: 'justify',
            },
            {
              text: 'https://ruvmx.sharepoint.com/sites/homeruv/Documentos%20de%20normatividad%20interna/Manual%20de%20Seguridad%20de%20la%20Informacio%CC%81n%20RUV.pdf',
              color: 'blue',
              link: 'https://ruvmx.sharepoint.com/sites/homeruv/Documentos%20de%20normatividad%20interna/Manual%20de%20Seguridad%20de%20la%20Informacio%CC%81n%20RUV.pdf',
              alignment: 'left',
            },
            {
              text: '), y se compromete a cumplirlas en su totalidad, ya que son parte integrante de las funciones y responsabilidades inherentes a sus labores, sin detrimento de las obligaciones y prohibiciones establecidas en el contrato, en el entendido de que el incumplimiento a cualquiera de éstos será causa de la aplicación de las sanciones correspondientes.',
              alignment: 'justify',
            },
          ],
          style: 'textStyle',
        },
        {
          margin: [0, 70, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 130, '*'],
            body: [
              [
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `${record.name} ${record.lastname}\n\n Recibe`,
                      style: 'textStyle',
                      fontSize: 8,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'left',
                },
                {
                  border: [false, false, false, false],
                  text: [{ text: '                 ' }],
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `Representante de la Gerencia de\n\n Infraestructura y Mantenimiento\n\n Entrega`,
                      style: 'textStyle',
                      fontSize: 8,
                      bold: true,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'right',
                },
              ],
              [
                {
                  colSpan: 3,
                  text: '\n\n\n\n',
                  border: [false, false, false, false],
                  alignment: 'left',
                },
              ],
            ],
          },
          layout: {
            hLineinline: function (i, node) {
              return 1;
            },
            vLineinline: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return {
          margin: [17, 0, 30, 0],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  image:
                    'data:image/png;base64,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',
                  width: 550,
                  height: 50,
                  alignment: 'center',
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
          },
        };
      },
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },
        footerText: {
          color: '#45535b',
          fontSize: 6.5,
          margin: [5, 2, 5, 2],
        },
        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options);
  } else if (
    subcompany.id === '6a021dde43c7d731bb25fe2e' ||
    subcompany.id === '6a02245e43c7d731bb2605c4' ||
    subcompany.id === '6a02248343c7d731bb260673'
  ) {
    // Geldmacht / Ayuntamiento Alvarado

    const header = await generateHeaderGeldmacht({
      companyName:
        (subcompany && subcompany.name) ||
        (subcompany && subcompany.company && subcompany.company.name) ||
        'H. Ayuntamiento de Alvarado, Ver.',
      title: 'Resguardo de Mobiliario y Equipo',
      subtitle: 'Resguardo de Bienes Muebles',
      date: `Fecha de Expedición\nDoc: ${moment().format('DD/MM/YYYY')}`,
    });

    const assets = record.assets || [];

    const emptyRows = Array.from({ length: Math.max(14 - assets.length, 0) }, () => [
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
    ]);

    const formatAssetDate = (value) => {
      if (!value) return '';

      return moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : '';
    };

    var docDefinition = {
      pageOrientation: 'landscape',
      pageMargins: [18, 18, 18, 22],

      content: [
        header,

        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 805,
              y2: 0,
              lineWidth: 1,
              lineColor: '#e9ecef',
            },
          ],
          margin: [0, 0, 0, 8],
        },

        { text: 'DATOS DEL RESGUARDO', style: 'sectionTitle' },

        {
          margin: [0, 0, 0, 10],
          table: {
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'FECHA', style: 'infoHeader' },
                { text: 'DEPARTAMENTO', style: 'infoHeader' },
                { text: 'DIRECCIÓN', style: 'infoHeader' },
                { text: 'UBICACIÓN', style: 'infoHeader' },
              ],
              [
                { text: moment().format('DD/MM/YYYY'), style: 'infoValue' },
                { text: record.department || record.area || '', style: 'infoValue' },
                { text: record.direction || '', style: 'infoValue' },
                { text: record.location || '', style: 'infoValue' },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#d8dee6',
            vLineColor: () => '#d8dee6',
          },
        },

        { text: 'BIENES ASIGNADOS', style: 'sectionTitle' },

        {
          table: {
            headerRows: 1,
            widths: [72, 62, '*', 58, 58, 78, 78, 72, 72, 68],

            body: [
              [
                { text: 'NO. INVENTARIO', style: 'assetHeader' },
                { text: 'BIEN', style: 'assetHeader' },
                { text: 'DESCRIPCIÓN', style: 'assetHeader' },
                { text: 'MARCA', style: 'assetHeader' },
                { text: 'MODELO', style: 'assetHeader' },
                { text: 'NO. SERIE', style: 'assetHeader' },
                { text: 'NO. FACTURA', style: 'assetHeader' },
                { text: 'FECHA COMPRA', style: 'assetHeader' },
                { text: 'IMPORTE AVALÚO', style: 'assetHeader' },
                { text: 'ESTADO FÍSICO', style: 'assetHeader' },
              ],

              ...assets.map((a, index) => [
                {
                  text: a.number || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.name || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.description || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.brand || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.model || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.serie || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.billNumber || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: formatAssetDate(a.buyDate || a.billDate),
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                {
                  text: a.amount || a.appraisalAmount || '',
                  style: index % 2 ? 'assetRow' : 'assetRowOdd',
                },

                { text: a.physicalState || '', style: index % 2 ? 'assetRow' : 'assetRowOdd' },
              ]),

              ...emptyRows.map((row, index) =>
                row.map(() => ({
                  text: '',
                  style: (assets.length + index) % 2 ? 'assetRow' : 'assetRowOdd',
                }))
              ),
            ],
          },

          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#ffffff',
            vLineColor: () => '#ffffff',
          },
        },

        {
          margin: [0, 10, 0, 0],
          table: {
            widths: [190, 180, 160, '*'],
            body: [
              [
                { text: 'RESPONSABLE', style: 'signatureHeader' },
                { text: 'REGISTRO FEDERAL', style: 'signatureHeader' },
                { text: 'FIRMA', style: 'signatureHeader' },
                { text: 'SELLO / OBSERVACIONES', style: 'signatureHeader' },
              ],
              [
                {
                  text: `${record.name || ''} ${record.lastname || ''}`,
                  style: 'signatureValue',
                },
                { text: record.rfc || '', style: 'signatureValue' },
                { text: '\n\n', style: 'signatureValue' },
                { text: '\n\n', style: 'signatureValue' },
              ],
            ],
          },

          layout: {
            hLineWidth: () => 0.7,
            vLineWidth: () => 0.7,
            hLineColor: () => '#cfd6df',
            vLineColor: () => '#cfd6df',
          },
        },

        {
          margin: [0, 8, 0, 0],
          columns: [
            {
              width: '*',
              stack: [
                { text: 'FUNDAMENTO LEGAL', style: 'legalTitle' },

                {
                  text:
                    'Original - Archivo\n' +
                    'C. C. P. - Usuario directo de los bienes muebles\n' +
                    'C. C. P. - Lic. Chareny de Jesús Ramón Ruiz\n\n' +
                    'Ley de Adquisiciones, Arrendamientos, Administración y Enajenación de Bienes Muebles del Estado de Veracruz.\n' +
                    'Artículo 93. Los servidores públicos que tengan bienes muebles bajo su custodia, resguardo o uso derivado, serán responsables de su cuidado y, en su caso, de su reposición y del resarcimiento de los daños y perjuicios causados.',
                  style: 'legalText',
                },
              ],
            },

            {
              width: 230,
              stack: [
                {
                  text: 'AUTORIZA',
                  style: 'legalTitle',
                  alignment: 'center',
                },

                {
                  text: '\n\nLic. Chareny de Jesús Ramón Ruiz\nOficial Mayor',
                  style: 'authorityText',
                  alignment: 'center',
                },
              ],
            },
          ],
        },
      ],

      footer: function (currentPage, pageCount) {
        return {
          margin: [18, 0, 18, 6],

          columns: [
            {
              text: `Página ${currentPage} de ${pageCount}`,
              fontSize: 7,
              color: '#45535b',
            },

            {
              text: 'Generado por SAAF',
              alignment: 'right',
              fontSize: 7,
              color: '#45535b',
            },
          ],
        };
      },

      styles: {
        sectionTitle: {
          bold: true,
          fontSize: 8,
          color: '#45535b',
          margin: [0, 2, 0, 4],
          characterSpacing: 0.4,
        },

        infoHeader: {
          bold: true,
          alignment: 'center',
          fillColor: '#45535b',
          color: '#ffffff',
          fontSize: 8,
          margin: [0, 4, 0, 4],
        },

        infoValue: {
          fontSize: 8,
          color: '#45535b',
          alignment: 'center',
          fillColor: '#f4f6f8',
          margin: [0, 5, 0, 5],
        },

        assetHeader: {
          bold: true,
          fillColor: '#45535b',
          color: '#ffffff',
          alignment: 'center',
          fontSize: 6.8,
          margin: [2, 4, 2, 4],
        },

        assetRow: {
          fontSize: 6.5,
          color: '#45535b',
          fillColor: '#ffffff',
          margin: [3, 4, 3, 4],
        },

        assetRowOdd: {
          fontSize: 6.5,
          color: '#45535b',
          fillColor: '#f4f6f8',
          margin: [3, 4, 3, 4],
        },

        signatureHeader: {
          bold: true,
          alignment: 'center',
          fillColor: '#45535b',
          color: '#ffffff',
          fontSize: 8,
          margin: [0, 4, 0, 4],
        },

        signatureValue: {
          fontSize: 8,
          color: '#45535b',
          alignment: 'center',
          margin: [4, 8, 4, 8],
        },

        legalTitle: {
          bold: true,
          fontSize: 7,
          color: '#45535b',
          margin: [0, 0, 0, 3],
        },

        legalText: {
          fontSize: 6.5,
          color: '#45535b',
          lineHeight: 1.15,
        },

        authorityText: {
          fontSize: 8,
          color: '#45535b',
          bold: true,
        },
      },
    };

    return output(docDefinition, options);
  } else if (subcompany.id === '6a0b811c1866b8396d8be4db') {
    // Caja Popular 9 de Agosto
    const header = await generateHeaderCajaPopular9Agosto({
      width: '*',
      text: `Fecha: ${moment().format('DD/MM/YYYY')}`,
      style: 'textStyle',
      alignment: 'right',
    });
    var docDefinition = {
      content: [
        header,
        {
          canvas: [
            {
              type: 'line',
              x1: 0, y1: 0,
              x2: 515, y2: 0,
              lineWidth: 1.5,
              lineColor: '#e9ecef',
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: 'CARTA RESPONSIVA',
          bold: true,
          fontSize: 11,
          color: '#45535b',
          margin: [0, 0, 0, 10],
        },
        {
          margin: [0, 0, 0, 10],
          table: {
            widths: [110, '*', 110, '*'],
            body: [
              [
                { text: 'SUCURSAL / DEPARTAMENTO:', bold: true, fontSize: 8, color: '#45535b', fillColor: '#f4f4f4', margin: [4, 5, 4, 5] },
                {
                  text: record.department || record.area || '',
                  fontSize: 9, color: '#45535b', margin: [4, 5, 4, 5],
                  colSpan: 3, fillColor: '#ffffff',
                },
                {}, {},
              ],
              [
                { text: 'DESCRIPCIÓN:', bold: true, fontSize: 8, color: '#45535b', fillColor: '#f4f4f4', margin: [4, 5, 4, 5] },
                {
                  text: '',
                  fontSize: 9, color: '#45535b', margin: [4, 5, 4, 5], fillColor: '#ffffff',
                },
                { text: 'NÚM. DE INVENTARIO:', bold: true, fontSize: 8, color: '#45535b', fillColor: '#f4f4f4', margin: [4, 5, 4, 5] },
                {
                  text: '',
                  fontSize: 9, color: '#45535b', margin: [4, 5, 4, 5], fillColor: '#ffffff',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: (i) => (i === 0 || i === 1 ? 2 : 1),
            vLineWidth: () => 0,
            hLineColor: () => '#e9ecef',
          },
        },
        {
          margin: [0, 0, 0, 10],
          table: {
            headerRows: 1,
            widths: [60, '*', 80, 80, 90],
            body: [
              [
                { text: 'NÚMERO', bold: true, fontSize: 10, color: '#45535b', margin: [10, 5, 0, 5] },
                { text: 'NOMBRE / DESCRIPCIÓN', bold: true, fontSize: 10, color: '#45535b', margin: [10, 5, 0, 5] },
                { text: 'MARCA', bold: true, fontSize: 10, color: '#45535b', margin: [10, 5, 0, 5] },
                { text: 'MODELO', bold: true, fontSize: 10, color: '#45535b', margin: [10, 5, 0, 5] },
                { text: 'SERIE', bold: true, fontSize: 10, color: '#45535b', margin: [10, 5, 0, 5] },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, fontSize: 9, color: '#45535b', fillColor: index % 2 ? '#ffffff' : '#f4f4f4', margin: [10, 5, 0, 5] },
                { text: a.name, fontSize: 9, color: '#45535b', fillColor: index % 2 ? '#ffffff' : '#f4f4f4', margin: [10, 5, 0, 5] },
                { text: a.brand, fontSize: 9, color: '#45535b', fillColor: index % 2 ? '#ffffff' : '#f4f4f4', margin: [10, 5, 0, 5] },
                { text: a.model, fontSize: 9, color: '#45535b', fillColor: index % 2 ? '#ffffff' : '#f4f4f4', margin: [10, 5, 0, 5] },
                { text: a.serie, fontSize: 9, color: '#45535b', fillColor: index % 2 ? '#ffffff' : '#f4f4f4', margin: [10, 5, 0, 5] },
              ]),
            ],
          },
          layout: {
            hLineWidth: (i) => (i === 0 || i === 1 ? 2 : 1),
            vLineWidth: () => 0,
            hLineColor: () => '#e9ecef',
          },
        },
        {
          margin: [0, 0, 0, 14],
          stack: [
            {
              text: [
                'Recibí de ',
                {
                  text: 'CAJA POPULAR 9 DE AGOSTO SALAMANCA S.C. DE A.P. DE R.L. DE C.V.',
                  bold: true,
                },
                ', el bien mueble que se describe al inicio de la presente, para que a partir de esta fecha la utilice para el desempeño de mis labores, comprometiéndome a su conservación y cuidado, obligándome a devolverlo en el momento que me sea requerido en las mismas condiciones que me fue entregado, salvo el desgaste por el uso normal ocasionado por la naturaleza de mis funciones.',
              ],
              style: 'textStyle',
            },
            {
              text: 'En caso de robo, extravío o descompostura, me obligo a reportarlo por escrito al departamento de Administración y Finanzas, para que deslinde la o las responsabilidades sobre el o los daños ocasionados al bien mueble. Así mismo me comprometo a no hacer mal uso de los accesorios con los que cuenta.',
              style: 'textStyle',
              margin: [0, 10, 0, 0],
            },
          ],
        },
        {
          margin: [0, 50, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 40, '*', 40, '*'],
            body: [
              [
                {
                  border: [false, true, false, false],
                  text: [
                    {
                      text: `${record.name} ${record.lastname}\n`,
                      bold: true,
                      style: 'textStyle',
                      fontSize: 9,
                      alignment: 'center',
                    },
                    {
                      text: 'NOMBRE DEL RESPONSABLE',
                      style: 'textStyle',
                      fontSize: 8,
                      alignment: 'center',
                    },
                  ],
                  alignment: 'center',
                },
                { text: '', border: [false, false, false, false] },
                {
                  border: [false, true, false, false],
                  text: [
                    { text: '\n', style: 'textStyle', fontSize: 9 },
                    { text: 'ENCARGADO DEL ÁREA', style: 'textStyle', fontSize: 8, alignment: 'center' },
                  ],
                  alignment: 'center',
                },
                { text: '', border: [false, false, false, false] },
                {
                  border: [false, true, false, false],
                  text: [
                    { text: '\n', style: 'textStyle', fontSize: 9 },
                    { text: 'AUTORIZA', style: 'textStyle', fontSize: 8, alignment: 'center' },
                  ],
                  alignment: 'center',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 0,
            hLineColor: () => '#45535b',
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return {
          margin: [18, 0, 18, 6],
          columns: [
            { text: `Página ${currentPage} de ${pageCount}`, fontSize: 7, color: '#45535b' },
            { text: 'Generado por SAAF', alignment: 'right', fontSize: 7, color: '#45535b' },
          ],
        };
      },
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 10,
          margin: [0, 0, 0, 0],
        },
      },
    };
    return output(docDefinition, options);
  }
  else {
    const header = await generateHeader(`${subcompany.name} \nVale de Resguardo`);

    var docDefinition = {
      content: [
        header,
        {
          margin: [0, 10, 0, 0],
          columnGap: 20,
          columns: [
            {
              width: '*',
              text: `Empleado: ${record.name} ${record.lastname}`,
              bold: true,
              style: 'textStyle',
            },
            {
              width: '100',
              text: `Fecha: ${moment().format('DD/MM/YYYY')}`,
              style: 'textStyle',
            },
          ],
        },
        { text: 'Recibí el equipo que se menciona a continuación:', style: 'textStyle' },
        {
          margin: [0, 20, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', 100, 100, 100, 90],
            body: [
              [
                { text: 'Número', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Nombre', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Marca', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Modelo', style: 'tableRow', bold: true, fontSize: 10 },
                { text: 'Serie', style: 'tableRow', bold: true, fontSize: 10 },
              ],
              ...record.assets.map((a, index) => [
                { text: a.number, bold: true, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.name, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.brand, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.model, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
                { text: a.serie, style: index % 2 ? 'tableRow' : 'tableRowOdd' },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#e9ecef';
            },
          },
        },
        {
          text: `El cual me comprometo a cuidar, mantener en buen estado y utilizar única y exclusivamente para asuntos relacionados con mi actividad laboral. En caso de su extravío, daño ó uso inadecuado, me responsabilizo a pagar el costo de reparación o la reposición del equipo.`,
          style: 'textStyle',
        },
        {
          margin: [0, 60, 0, 0],
          table: {
            headerRows: 0,
            widths: ['*', 200, '*'],
            body: [
              [
                { text: '', border: [false, false, false, false] },
                signedCell(
                  {
                    text: `${record.name} ${record.lastname}\n Recibe`,
                    style: 'tableRow',
                    bold: true,
                    fontSize: 10,
                    alignment: 'center',
                    border: [false, true, false, false],
                  },
                  options.signature
                ),
                { text: '', border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return '#45535b';
            },
          },
        },
      ],
      styles: {
        textStyle: {
          color: '#45535b',
          fontSize: 11,
          margin: [0, 20, 0, 0],
        },

        tableRow: {
          color: '#45535b',
          fontSize: 9,
          margin: [10, 5, 0, 5],
        },
        tableRowOdd: {
          color: '#45535b',
          fontSize: 9,
          fillColor: '#f4f4f4',
          margin: [10, 5, 0, 5],
        },
      },
    };

    return output(docDefinition, options, { inBlock: true });
  }
};



// WEBPACK FOOTER //
// src/lib/pdfs/EmployeesAssetsPDF.js